module.exports = __webpack_public_path__ + "static/media/son-thumbnailMOBILE.75095888.jpg";